import { DomainProvider } from "@4uhub/lib4uhub";
import { RouteObject } from "react-router-dom";
import AutomationRule from "../pages/4uChatbot/Automations/AutomationRules/AutomationRuleForm/AutomationRule";
import AutomationRulesPage from "../pages/4uChatbot/Automations/AutomationRules/AutomationRulesPage";
import ServiceWhatsappPage from "../pages/4uChatbot/Flows/ServiceWhatsapp/ServiceWhatsappPage";
import WelcomePage from "../pages/welcomePage";
import InternalTemplatesPage from "../pages/4uChatbot/Templates/InternalTemplates/InternalTemplatesPage";
import TicketServiceArea from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceArea/TicketServiceAreaForm/TicketServiceArea";
import TicketServiceAreaPage from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceArea/TicketServiceAreaPage";
import ServiceDay from "../pages/4uChatbot/RegistrationsAndRules/ServiceDays/ServiceDayForm/ServiceDay";
import ServiceDayPage from "../pages/4uChatbot/RegistrationsAndRules/ServiceDays/ServiceDayPage";
import TicketServiceMessagePage from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceMessage/TicketServiceMessagePage";
import TicketServiceMessage from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceMessage/TicketServiceMessageForm/TicketServiceMessage";
import NewTicketServiceMessage from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceMessage/TicketServiceMessageForm/NewTicketServiceMessage";
import { BlacklistPage } from "../pages/4uChatbot/RegistrationsAndRules/Blacklist/BlacklistPage";
import { Blacklist } from "../pages/4uChatbot/RegistrationsAndRules/Blacklist/BlacklistForm/Blacklist";
import AutomationReceivedRulesPage from "../pages/4uChatbot/Automations/AutomationReceivedRules/AutomationReceivedRulesPage";
import AutomationReceivedRule from "../pages/4uChatbot/Automations/AutomationReceivedRules/AutomationReceivedRulesForm/AutomationReceivedRule";
import { TicketFinishReason } from "../pages/4uChatbot/RegistrationsAndRules/TicketFinishReason/TicketFinishReasonForm/TicketFinishReason";
import { TicketFinishReasonPage } from "../pages/4uChatbot/RegistrationsAndRules/TicketFinishReason/TicketFinishReasonPage";
import TemplateGeneralPage from "../pages/4uChatbot/Templates/TemplateGenerals/TemplateGeneralPage";
import TemplateGeneral from "../pages/4uChatbot/Templates/TemplateGenerals/TemplateGeneralForm/TemplateGeneral";
import { MemberAvailabilityPauseReasonPage } from "../pages/4uChatbot/RegistrationsAndRules/MemberAvailabilityPauseReason/MemberAvailabilityPauseReasonPage";
import { MemberAvailabilityPauseReason } from "../pages/4uChatbot/RegistrationsAndRules/MemberAvailabilityPauseReason/MemberAvailabilityPauseReasonForm/MemberAvailabilityPauseReason";
import { WhatsappPage } from "../pages/4uChatbot/Templates/Whatsapp/WhatsappPage";
import { Whatsapp } from "../pages/4uChatbot/Templates/Whatsapp/WhatsappForm/Whatsapp";
import BanListPage from "../pages/4uChatbot/RegistrationsAndRules/BanList/BanListPage";
import BanList from "../pages/4uChatbot/RegistrationsAndRules/BanList/BanListForm/BanList";
import TicketHistories from "../pages/4uChatbot/Logs/TicketHistories/TicketHistories";
import CalendarControlPage from "../pages/4uChatbot/Logs/CalendarControl/CalendarControlPage";
import AppointmentArrivalPage from "../pages/4uChatbot/RegistrationsAndRules/AppointmentArrival/AppointmentArrivalPage";
import AppointmentArrival from "../pages/4uChatbot/RegistrationsAndRules/AppointmentArrival/AppointmentArrivalForm/AppointmentArrival";
import ExamSchedulingAttachmentLog from "../pages/4uChatbot/Logs/ExamSchedulingAttachmentLog/ExamSchedulingAttachmentLogs";

const chatBotRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "templates/whatsapp",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationtemplates" }}>
        <WhatsappPage />
      </DomainProvider>
    ),
  },
  {
    path: "templates/whatsapp/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautomationtemplates" }}
        actions={["Create"]}
      >
        <Whatsapp />
      </DomainProvider>
    ),
  },
  {
    path: "templates/whatsapp/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationtemplates" }}>
        <Whatsapp />
      </DomainProvider>
    ),
  },
  {
    path: "templates/general/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationtemplates" }}>
        <TemplateGeneral />
      </DomainProvider>
    ),
  },
  {
    path: "templates/general",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationtemplates" }}>
        <TemplateGeneralPage />
      </DomainProvider>
    ),
  },
  {
    path: "templates/general/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautomationtemplates" }}
        actions={["Create"]}
      >
        <TemplateGeneral />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/automationRules",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationrule" }}>
        <AutomationRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/automationRules/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautomationrule" }}
        actions={["Create"]}
      >
        <AutomationRule />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/automationRules/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationrule" }}>
        <AutomationRule />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/receivedAutomationRules",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationrule" }}>
        <AutomationReceivedRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/receivedAutomationRules/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautomationrule" }}
        actions={["Create"]}
      >
        <AutomationReceivedRule />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/receivedAutomationRules/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautomationrule" }}>
        <AutomationReceivedRule />
      </DomainProvider>
    ),
  },
  {
    path: "fluxos/serviceWhatsapp",
    element: (
      <DomainProvider value={{ domainName: "all" }}>
        <ServiceWhatsappPage />
      </DomainProvider>
    ),
  },
  {
    path: "templates/internal",
    element: (
      <DomainProvider value={{ domainName: "internaltemplate" }}>
        <InternalTemplatesPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceArea",
    element: (
      <DomainProvider value={{ domainName: "ticketservicearea" }}>
        <TicketServiceAreaPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceArea/new",
    element: (
      <DomainProvider value={{ domainName: "ticketservicearea" }}>
        <TicketServiceArea />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceArea/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservicearea" }}>
        <TicketServiceArea />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceDay",
    element: (
      <DomainProvider value={{ domainName: "ticketserviceday" }}>
        <ServiceDayPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceDay/new",
    element: (
      <DomainProvider value={{ domainName: "ticketserviceday" }}>
        <ServiceDay />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceDay/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketserviceday" }}>
        <ServiceDay />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceMessage",
    element: (
      <DomainProvider value={{ domainName: "ticketservicemessage" }}>
        <TicketServiceMessagePage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceMessage/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketservicemessage" }}
        actions={["Create"]}
      >
        <NewTicketServiceMessage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketServiceMessage/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservicemessage" }}>
        <TicketServiceMessage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/blacklist",
    element: (
      <DomainProvider value={{ domainName: "ticketblacklist" }}>
        <BlacklistPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/blacklist/new",
    element: (
      <DomainProvider value={{ domainName: "ticketblacklist" }}>
        <Blacklist />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/blacklist/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketblacklist" }}>
        <Blacklist />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketFinishReason",
    element: (
      <DomainProvider value={{ domainName: "ticketfinishreason" }}>
        <TicketFinishReasonPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketFinishReason/new",
    element: (
      <DomainProvider value={{ domainName: "ticketfinishreason" }}>
        <TicketFinishReason />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketFinishReason/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketfinishreason" }}>
        <TicketFinishReason />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketChannelMemberAvailabilityPauseReason",
    element: (
      <DomainProvider
        value={{ domainName: "Ticketchannelmemberavailabilitypausereason" }}
      >
        <MemberAvailabilityPauseReasonPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketChannelMemberAvailabilityPauseReason/new",
    element: (
      <DomainProvider
        value={{ domainName: "Ticketchannelmemberavailabilitypausereason" }}
      >
        <MemberAvailabilityPauseReason />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/ticketChannelMemberAvailabilityPauseReason/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "Ticketchannelmemberavailabilitypausereason" }}
      >
        <MemberAvailabilityPauseReason />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/banList",
    element: (
      <DomainProvider value={{ domainName: "ticketservicebanlist" }}>
        <BanListPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/banList/new",
    element: (
      <DomainProvider value={{ domainName: "ticketservicebanlist" }}>
        <BanList />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/banList/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservicebanlist" }}>
        <BanList />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/appointmentArrivalRule",
    element: (
      <DomainProvider value={{ domainName: "appointmentarrivalrule" }}>
        <AppointmentArrivalPage />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/appointmentArrivalRule/new",
    element: (
      <DomainProvider value={{ domainName: "appointmentarrivalrule" }}>
        <AppointmentArrival />
      </DomainProvider>
    ),
  },
  {
    path: "registrationsAndRules/appointmentArrivalRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "appointmentarrivalrule" }}>
        <AppointmentArrival />
      </DomainProvider>
    ),
  },
  {
    path: "logs/ticketsHistory",
    element: (
      <DomainProvider value={{ domainName: "tickethistorylogs" }}>
        <TicketHistories />
      </DomainProvider>
    ),
  },
  {
    path: "logs/calendarControl",
    element: (
      <DomainProvider value={{ domainName: "calendarcontrolxl" }}>
        <CalendarControlPage />
      </DomainProvider>
    ),
  },
  {
    path: "logs/examSchedulingAttachmentLog",
    element: (
      <DomainProvider value={{ domainName: "examschedulingattachmentlog" }}>
        <ExamSchedulingAttachmentLog />
      </DomainProvider>
    ),
  },
];

export default chatBotRoutes;
